/**
 * DPO — Detrended Price Oscillator.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.DPO). Painel próprio, 1 linha, SEM parâmetros (as janelas 20 e 11 são
 * fixas no engine — a classe não tem `AddParam`):
 *
 *   DPO = C − REF(MA(C,20), 11)
 *
 * Remove a tendência do preço comparando o fechamento com a média deslocada,
 * o que evidencia os ciclos curtos. Paridade provada em
 * __tests__/dpo.silverlight.test.js.
 */
import { ma, ref, sub } from "./silverlightDsl";

// Fixos no engine (MA de 20 períodos deslocada 11 barras).
const MA_WINDOW = 20;
const SHIFT = 11;

export default function () {
  let options = {};

  function calculator(data) {
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );
    const dpo = sub(close, ref(ma(close, MA_WINDOW), SHIFT));
    return dpo.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    return MA_WINDOW - 1 + SHIFT;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...x };
    return calculator;
  };

  return calculator;
}
